// extracted by mini-css-extract-plugin
module.exports = {"keys":"ri_LjJ","key":"lTxl1W"};